<template>
  <div id="app">
    <nav class="navbar is-fixed-top has-shadow" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <div class="navbar-item">
          <a class="title is-4" href="https://leavemyunion.com">{{content.title}}</a>
        </div>

        <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" data-target="navMenu" >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div  id="navMenu" class="navbar-menu">
        <div class="navbar-start is-hidden-tablet">
          <div class="navbar-item" v-for="(item, index) in content.sections" v-bind:key="index">
            <a v-bind:href="item.anchor">{{item.title}}</a>
          </div>
        </div>
        <div class="navbar-end is-hidden-mobile">
          <div class="navbar-item">
            <a class="button is-dark" v-on:click="openInstructions">{{content.cta.nav}}</a>
          </div>
        </div>
      </div>
    </nav>

    <section class="hero is-primary is-medium">
      <div class="hero-background"></div>
      <div class="hero-body">
        <div class="container">
          <h1 class="title bordered">{{content.hero.title}}</h1>
        </div>
      </div>
    </section>

    <section class="details section">
        <div class="container">
          <section class="intro">
            <div class="content" v-html="content.text"/>
          </section>

          <b-collapse class="card" v-on:open="openCard(item.title)" v-for="(item, index) in content.sections" v-bind:open="false" v-bind:key="index" v-bind:id="subAnchor(item.anchor)">
            <div slot="trigger" slot-scope="props" class="card-header">
              <p class="card-header-title">{{item.title}}</p>
              <a class="card-header-icon">
                <b-icon :icon="props.open ? 'chevron-down' : 'chevron-up'" />
              </a>
            </div>

            <div class="card-content">
              <div class="content" v-html="item.content"></div>

              <div v-if="item.anchor === '#howoptout'">
                <div class="has-text-centered button-bar">
                  <a class="button is-dark" v-on:click="openInstructions" v-html="content.cta.lower"></a>
                </div>
                <div class="notification has-text-centered-mobile">
                  <p class v-html="content.cta.help"></p>
                </div>
              </div>

              <div v-if="item.anchor === '#fairshare'">
                <div class="has-text-centered button-bar">
                  <a class="button is-dark" v-on:click="openInstructions">You can download and print a letter by selecting your union here</a>
                </div>
                <div class="notification has-text-centered-mobile">
                  <p v-html="content.cta.share"></p>
                </div>
              </div>
            </div>
          </b-collapse>

          <div class="contact-bar">
            <div class="notification is-dark has-text-centered"><p>Would you like to share your union story? Email us at <a href="mailto:help@leavemyunion.com">help@leavemyunion.com</a>.</p></div>
          </div>
        </div>
    </section>

    <InstructionDialog v-bind:show="showInstructions" v-bind:content="content" v-on:close="closeInstructions"/>

    <footer class="footer">
      <div class="columns is-centered">
        <div class="column is-8">
          <div class="content has-text-centered">
            <p><strong>{{content.footer.title}}</strong></p>
            <p v-html="content.footer.subtitle"></p>
            <p v-html="content.footer.legal" class="legal"></p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import InstructionDialog from './components/InstructionDialog.vue'
import Content from './components/Content.json'
import BCollapse from "buefy/src/components/collapse/Collapse";

let gtag; // mock global
let fbq;  // mock global

export default {
  name: 'app',
  components: {
    BCollapse,
    InstructionDialog
  },
  data: function() {
    const x = Content.instructions[window.location.hash.toLowerCase().replace('#', '')] !== undefined;
    return {
      'showInstructions': x,
      'content': Content
    };
  },
  methods: {
    openInstructions: function() {
      if (this.content.enabled.length == 1) {
        window.location.hash = this.content.enabled[0];
      }
      this.showInstructions = true;
    },
    closeInstructions: function() {
      this.showInstructions = false;
    },
    subAnchor: function(anchor) {
      return anchor.replace('#', '');
    },
    openCard: function(label) {
      window.gtag('event', 'expand', {
        'event_label': label
      });
    }
  }
}
</script>

<style lang="scss">
@import 'src/assets/sass/main.scss';

body {
  font-size: 1.1rem;

  a {
    font-weight: bold;
    color: #0F1929;
    font-style: normal;
  }

  .title,
  .button {
    font-family: 'Roboto Slab', serif;
    white-space: unset;
    height: auto;
  }

  .button {
    font-weight: normal !important;
    font-style: italic;
    &.is-dark {
      background-color: #0F1929;
      color: white !important;
    }
  }

  .notification {
    a {
      color: inherit;
      text-decoration: none;
    }
    &.is-dark {
      background-color: #0F1929;
    }
  }
}

#app {

  section.intro {
    margin-bottom: 2rem;
  }
  .details {
    margin-bottom: 2rem;
  }

  .content {
    h3 {
      font-size: 1.25rem;
    }
    table th {
      width: 100px;
    }
    ul {
      border-left: 5px solid #97ABB4;
      padding-left: 31px;
    }
    .button {
      margin-top: 0.5rem;
      margin-bottom: 0.5rem;
    }
  }

  .button-bar {
    margin: 2rem 0;
  }

  .details {
    margin-top: 2em;
    .section {
      h2 {
        position: sticky;
        top: 52px;
        background: white;
        padding-bottom: 1.5rem;
        margin-bottom: 0;
        padding-top: 1.5rem;
        margin-top: 0;
        z-index: 10;
      }
    }
    .section-wrap:nth-child(even) .section,
    .section-wrap:nth-child(even) .section h2 {
      background-color: #ededed;
    }
  }

  aside.menu {
    position: sticky;
    top: 55px;
  }

  footer {
    .legal {
      font-size: smaller;
    }
  }

  .box {
    margin-top: 1rem;
  }

  .card {
    margin-bottom: 1rem;
  }

  .hero {
    position: relative;
    margin-top: 55px;
    .title {
      color: white;
      //color: #111B2A;
      &.bordered {
        border-left: 4px solid white;
        padding-left: 1rem;
        margin-right: 50%;
      }
    }
    &.is-medium .hero-body {
      padding-top: 5rem;
      padding-bottom: 5rem;
    }
    .hero-background {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;

      background-image: url('https://leaveafscme.com/header.jpg');
      background-size: cover;
      background-position: 0;
      filter: grayscale(80%);
      opacity: 0.9;
    }
    .hero-background::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      background: rgba(103, 124, 132, 0.8);
      background: -moz-linear-gradient(left, rgba(103, 124, 132, 0.8) 0%, rgba(103, 124, 132, 0.8) 15%, rgba(134, 155, 165, 0.8) 71%, rgba(134, 155, 165, 0.8) 100%);
      background: -webkit-linear-gradient(left, rgba(103, 124, 132, 0.8) 0%, rgba(103, 124, 132, 0.8) 15%, rgba(134, 155, 165, 0.8) 71%, rgba(134, 155, 165, 0.8) 100%);
      background: -o-linear-gradient(left, rgba(103, 124, 132, 0.8) 0%, rgba(103, 124, 132, 0.8) 15%, rgba(134, 155, 165, 0.8) 71%, rgba(134, 155, 165, 0.8) 100%);
      background: -ms-linear-gradient(left, rgba(103, 124, 132, 0.8) 0%, rgba(103, 124, 132, 0.8) 15%, rgba(134, 155, 165, 0.8) 71%, rgba(134, 155, 165, 0.8) 100%);
      background: linear-gradient(to right, rgba(103, 124, 132, 0.8) 0%, rgba(103, 124, 132, 0.8) 15%, rgba(134, 155, 165, 0.8) 71%, rgba(134, 155, 165, 0.8) 100%);
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#677c84', endColorstr='#869ba5', GradientType=1 );
    }
  }

  @media (max-width : 600px) {
    .content ul { margin-left: 0; }
    .modal-instructions .section { padding-left: 0; padding-right: 0; }
    .modal-instructions .section .section { padding-top: 0; padding-left: 1px; padding-right: 1px; padding-bottom: 1rem; }
    .modal-instructions .tips ul li {
      font-size: smaller;
      margin-bottom: 1rem;
    }
    #app .hero .title.bordered {
      margin-right: 20%;
    }
  }

}
</style>
